import { action, computed, makeObservable, observable } from 'mobx'
import {
  ProgressionEditorViewModel,
  RegularEditorViewModel,
} from './BillingEditorViewModel'
import {
  ExtensionBillingInfoType,
  InventoryItemExtensionBillingType,
  InventoryItemExtensionType,
  InventoryItemExtensionTypeSpecification,
} from '../../../InventoryItem'
import { isExtensionBillingEnabled } from 'admin/inventory/extension-enabled-toggle'

export class ExtensionBillingViewModel {
  billingType: InventoryItemExtensionBillingType =
    InventoryItemExtensionBillingType.FlatFee

  enableExtensionJobProgressionBillingInfo: boolean = false

  /**
   * The type of extension inventory item.
   */
  extensionType: InventoryItemExtensionType =
    InventoryItemExtensionType.Personal

  regularBillingVM = new RegularEditorViewModel(() => this.billingType)

  progressionBillingVM = new ProgressionEditorViewModel(() => this.billingType)

  constructor() {
    makeObservable(this, {
      reset: action.bound,
      setExtensionJobProgressionBillingInfo: action.bound,
      setExtensionBillingType: action.bound,
      setExtensionType: action.bound,
      billingType: observable,
      enableExtensionJobProgressionBillingInfo: observable,
      extensionType: observable,
      billingVM: computed,
      hydrate: action.bound,
      isExtensionBillingEnabled: computed,
    })
  }

  get billingVM() {
    return this.enableExtensionJobProgressionBillingInfo
      ? this.progressionBillingVM
      : this.regularBillingVM
  }

  get isExtensionBillingEnabled() {
    return isExtensionBillingEnabled()
  }

  setExtensionJobProgressionBillingInfo(enabled: boolean) {
    this.enableExtensionJobProgressionBillingInfo = enabled

    this.billingVM.reset()
  }

  setExtensionType(extensionType: InventoryItemExtensionType) {
    this.extensionType = extensionType
  }

  setExtensionBillingType(
    extensionBillingType: InventoryItemExtensionBillingType,
  ) {
    this.billingType = extensionBillingType
  }

  reset() {
    this.billingType = InventoryItemExtensionBillingType.FlatFee
    this.enableExtensionJobProgressionBillingInfo = false
    this.regularBillingVM.reset()
    this.progressionBillingVM.reset()
  }

  hydrate(typeSpecification: InventoryItemExtensionTypeSpecification): void {
    this.extensionType = typeSpecification.extensionType
    this.billingType = typeSpecification.billingType
    this.enableExtensionJobProgressionBillingInfo =
      typeSpecification.billingInfo.type ===
      ExtensionBillingInfoType.Progression
    this.billingVM.hydrate(typeSpecification.billingInfo)
  }

  validate() {
    return this.enableExtensionJobProgressionBillingInfo
      ? true
      : this.regularBillingVM.validate()
  }
}
